import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Enforce email verification for email/password signups
  // OAuth users (Google etc.) are pre-verified by the provider
  const isOAuth = user.app_metadata?.provider && user.app_metadata.provider !== "email";
  if (!isOAuth && !user.email_confirmed_at) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center px-6">
        <div className="max-w-md text-center space-y-4">
          <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mx-auto">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
          </div>
          <h1 className="font-display text-xl font-bold text-foreground tracking-tight">
            Verify your email
          </h1>
          <p className="text-sm font-mono text-muted-foreground">
            We sent a verification link to <span className="text-foreground">{user.email}</span>. Please check your inbox and click the link to access your dashboard.
          </p>
          <button
            onClick={() => window.location.href = "/auth"}
            className="text-xs font-mono text-primary hover:underline"
          >
            ← Back to sign in
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
